import { createTheme } from '@mui/material/styles';
import { themeColors } from './theme';

/**
 * Create Material-UI theme based on dark/light mode
 * @param {boolean} isDarkMode - Whether dark mode is active
 * @returns {Object} MUI theme object
 */
export const createAppTheme = (isDarkMode) => {
  const colors = isDarkMode ? themeColors.dark : themeColors.light;

  return createTheme({
    palette: {
      mode: isDarkMode ? 'dark' : 'light',
      primary: {
        main: colors.primary, // #2563EB
        dark: colors.primaryDark, // #1D4ED8
        light: colors.primary, // Same as main for consistency
        contrastText: '#ffffff', // White text on primary background
      },
      background: {
        default: colors.shellBackground,
        paper: isDarkMode ? colors.backgroundSecondary : colors.white,
      },
      text: {
        primary: colors.textPrimary,
        secondary: colors.textSecondary,
      },
      divider: colors.border,
      error: {
        main: colors.error,
      },
      warning: {
        main: colors.warning,
      },
      success: {
        main: colors.success,
      },
      info: {
        main: colors.info,
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            transition: 'background-color 0.3s ease, color 0.3s ease',
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            // Pozadie riadi palette.background.paper — hardcoded override rozbíjal
            // kontrast kariet (light: undefined, dark: farba pozadia)
            transition: 'background-color 0.3s ease',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: 10,
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: 8,
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: colors.background,
            color: colors.textPrimary,
            transition: 'background-color 0.3s ease',
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            backgroundColor: colors.background,
            borderRight: `1px solid ${colors.border}`,
            transition: 'background-color 0.3s ease, border-color 0.3s ease',
          },
        },
      },
    },
    shape: {
      borderRadius: 12,
    },
    typography: {
      fontFamily: [
        '"Inter"',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
      ].join(','),
    },
  });
};

